import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as FormServices from "../../../../services/FormService";
import { useTranslation } from "react-i18next";
import FormForm from "./formForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";

export const generateRandomCode = (length = 6) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let result = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
};

const FormFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({
    frontCode: generateRandomCode(),
  });
  const [inputField, setInputField] = useState("");
  const [fields, setFields] = useState([]);

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      name: data.name,
      frontCode: data.frontCode,
      personType: data.personType.map((d) => d + ""),
      active: data.active,
      description: data.description,
      fields: data.fields,
    };
    setFields(data.fields);
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await FormServices.getForm(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        values.fields = fields;

        if (uuid) {
          result = await FormServices.updateForm(values, uuid);
        } else {
          result = await FormServices.addForm(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.form.messages.update.title");
            text = t("forms.form.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.form.messages.create.title");
            text = t("forms.form.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.form.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.FORM_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.FORM_LIST);
  };

  const handleAddField = () => {
    if (inputField.trim() !== "") {
      setFields([...fields, inputField]);
      setInputField("");
    }
  };

  const handleRemoveField = (index) => {
    const newItems = fields.filter((_, i) => i !== index);
    setFields(newItems);
  };

  return (
    <FormForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={handleOnback}
      onAddField={handleAddField}
      onRemoveField={handleRemoveField}
      fields={fields}
      inputField={inputField}
      setInputField={setInputField}
    />
  );
};

FormFormContainer.propTypes = {
  t: PropTypes.any,
};

export default FormFormContainer;
